export default __webpack_public_path__ + "static/media/dp-snake-game.514618d6.png";